
import { Component, Vue } from 'vue-property-decorator'

import { ShopDonate } from '@/lib/models/ShopDonate'
import { Numbers } from '@/lib/utils/Numbers'
import { Http } from '@/lib/utils/Http'

@Component({
  methods: {
    round2Decimal: Numbers.round2Decimal
  }
})
export default class Charity extends Vue {
  private donation: ShopDonate = new ShopDonate();
  private donationOrderSum: number | null = null;
  private donationOrderCount: number | null = null;
  private highestDonations: object | null = null;
  private latestDonations: object | null = null;
  private highestActiveRallyRounds:
    | {
        rally_id: number;
        round_name: string;
        sum: number;
        rally_name: string;
      }[]
    | null = null;

  private searchQuery = '';
  private foundTeams: object | null = null;

  private mounted () {
    this.loadDonation()
    this.loadDonationOrderSum()
    this.loadDonationOrderCount()
    this.loadHighestDonations()
    this.loadLatestDonations()
    this.loadHighestActiveRallyRounds()
  }

  private async loadDonation () {
    // this is hardcoded, currently only one charity is supported by the code
    this.donation = (await (await Http.request('/api/shop-donate')).json())[0]
  }

  private async loadDonationOrderSum () {
    // here also "0" is hardcoded for the shop_donate_id
    this.donationOrderSum = (
      await (await Http.request('/api/donate-order-sum/1')).json()
    ).sum
  }

  private async loadDonationOrderCount () {
    // here also "0" is hardcoded for the shop_donate_id
    this.donationOrderCount = (
      await (await Http.request('/api/donate-order-count/1')).json()
    ).count
  }

  private async loadHighestDonations () {
    this.highestDonations = await (
      await Http.request('/api/donate-order-count/highest/1')
    ).json()
  }

  private async loadLatestDonations () {
    this.latestDonations = await (
      await Http.request('/api/donate-order-count/latest/1')
    ).json()
  }

  private async loadHighestActiveRallyRounds () {
    this.highestActiveRallyRounds = await (
      await Http.request('/api/donate-order-count/rallies/highest/active/1')
    ).json()
  }

  private async searchTeams () {
    this.foundTeams = await (
      await Http.request('/api/team/search/' + this.searchQuery)
    ).json()
  }

  get highestRallySum (): number {
    if (!this.highestActiveRallyRounds) {
      return 0
    }
    return Math.max(
      ...this.highestActiveRallyRounds.map((rallyRound) => {
        return rallyRound.sum
      })
    )
  }
}
